module.exports = __webpack_public_path__ + "img/icon_play(1).d043f620.svg";